export default __webpack_public_path__ + "static/media/detail_mobile_12_7.68cf86f1.jpg";